export default __webpack_public_path__ + "static/media/swirl-green.0eedaa08.svg";